import React, {useState } from "react";
import DatePicker from "react-datepicker";
import "./styles/DatePickerStyle.css";
import styles from "./styles/Billing.module.css"
import { formatDate } from "../../../Utils/formatDate";
function TableFilter({filter, setFilter, handleChange, DownloadCSV, displayCalendar=true}) {

  const [showCalendarFrom, setShowCalendarFrom] = useState(false)
  const [showCalendarTo, setShowCalendarTo] = useState(false)

  return (
    <div className={styles.filter_div}>
    <div className={styles.left}>
        <div className={styles.input}>
        <div onClick={()=>null} className={styles.search_logo}></div>
        <input onChange={(e)=>setTimeout(()=>handleChange(e.target.value, "filter_value"), 500)} placeholder="Search" className={styles.input_input}></input>
        </div>
        <div className={styles.calendar} style={{display:displayCalendar?'block':'none'}}>

          <div className={styles.calendar_left}>From</div>
          <div className={styles.calendar_center}>
            <span onClick={()=>setShowCalendarFrom((prevState)=>!prevState)}>{formatDate(filter.min_date).split(' ')[0]}</span>
            <DatePicker open={showCalendarFrom} className={styles.datePicker_Main} onChange={(date)=>{setShowCalendarFrom((prevState)=>!prevState);handleChange(date.getTime(), "min_date")}}/>
          </div>
          <div className={styles.calendar_right} onClick={()=>setShowCalendarFrom((prevState)=>!prevState)}></div>
        </div>
        <div className={styles.calendar} style={{display:displayCalendar?'block':'none'}}>
          <div className={styles.calendar_left}>To</div>
          
          <div className={styles.calendar_center}>
            <span onClick={()=>setShowCalendarTo((prevState)=>!prevState)}>{formatDate(filter.max_date).split(' ')[0]}</span>
            <DatePicker  open={showCalendarTo} className={styles.datePicker_Main} onChange={(date)=>{setShowCalendarTo((prevState)=>!prevState);handleChange(date.getTime(), "max_date")}}/>
          </div>
          <div className={styles.calendar_right} onClick={()=>setShowCalendarTo((prevState)=>!prevState)}></div>

        </div>
    </div>
    <div onClick={(e)=>(DownloadCSV(filter))} className={styles.right}>
        {/* <div className={styles.add_logo}></div> */}
        <div className={styles.add_new_asset}>Export To CSV</div>
    </div>
    </div>
  );
}

export default TableFilter;
